export const messages = {
  en: {
    listOwner: {
      title: 'Owner Management',
      searchTitle: 'Search Conditions',
      ownerInfo: 'Owner Information',
      selectRoom: 'Select Room',
      role: {
        all: 'All',
        owner: 'Owner',
        tenant: 'Tenant'
      },
      personType: {
        personal: 'Personal',
        company: 'Company'
      },
      personTypeName: 'Person Type',
      gender: {
        male: 'Male',
        female: 'Female'
      },
      columns: {
        face: 'Face',
        name: 'Name',
        type: 'Type',
        role: 'Role',
        gender: 'Gender',
        idCard: 'ID Card',
        phone: 'Phone',
        backupPhone: 'Backup Phone',
        address: 'Address',
        rooms: 'Rooms',
        members: 'Members',
        cars: 'Cars',
        debts: 'Debts',
        operation: 'Operation'
      },
      placeholders: {
        name: 'Please enter name',
        room: 'Building-Unit-Room',
        phone: 'Please enter phone',
        idCard: 'Please enter ID card'
      },
      buttons: {
        search: 'Search',
        reset: 'Reset',
        add: 'Add',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        bindRoom: 'Bind Room',
        unbindRoom: 'Unbind Room',
        member: 'Member',
        detail: 'Detail'
      },
      actions: {
        editOwner: 'Edit Owner',
        deleteOwner: 'Delete Owner',
        addRoom: 'Add Room'
      },
      confirmDelete: 'Are you sure to delete?'
    }
  },
  zh: {
    listOwner: {
      title: '员工管理',
      searchTitle: '查询条件',
      ownerInfo: '员工信息',
      selectRoom: '选择房屋',
      role: {
        all: '全部',
        owner: '员工',
        tenant: '租客'
      },
      concactPerson: "成员",
      personType: {
        personal: '个人',
        company: '公司'
      },
      personTypeName: '人员类型',
      gender: {
        male: '男',
        female: '女'
      },
      columns: {
        face: '人脸',
        name: '客户名称',
        type: '人员类型',
        role: '人员角色',
        gender: '性别',
        idCard: '证件号',
        phone: '联系手机',
        backupPhone: '备用手机',
        address: '地址',
        contractDate: "合同签订日期",
        tax: "税收",
        industryType: "行业分类",
        companyOutput: "公司产值",
        revenue: "营收",
        rooms: '房屋数',
        members: '员工成员',
        cars: '车辆数',
        debts: '欠费',
        operation: '操作'
      },
      placeholders: {
        name: '请输入客户名称',
        room: '楼栋-单元-房屋',
        phone: '请输入联系方式',
        idCard: '请输入员工身份证号'
      },
      buttons: {
        search: '查询',
        reset: '重置',
        add: '添加',
        export: '导出',
        save: '保存',
        cancel: '取消',
        edit: '修改',
        delete: '删除',
        bindRoom: '入住房屋',
        unbindRoom: '房屋解绑',
        member: '成员',
        detail: '详情'
      },
      actions: {
        editOwner: '修改员工',
        deleteOwner: '删除员工',
        addRoom: '入住房屋'
      },
      confirmDelete: '确认是否删除！'
    }
  }
}